import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ChangeDetectorRef, Component, Input, ViewEncapsulation } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from '../../../environments/environment';
import { AttachmentImageComponent } from "./attachmentimage.component";
import { CommonModule } from "@angular/common";
import { TPipe } from '../i18n/t.pipe';

@Component({
    selector: 'charla-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.scss'],
    imports: [TPipe, CommonModule, AttachmentImageComponent]
})
export class AttachmentComponent {

    @Input() name: string;
    @Input() container: string = "messages-attachments"
    path: string;
    token: string;
    is_image: boolean = null;
    is_audio: boolean = false;
    filename: string;
    size: string;
    base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

    constructor(
            private http: HttpClient, 
            private cd: ChangeDetectorRef,
            private modalService: NgbModal,

        ){
        

    }

    ngOnInit() {

        this.path  = environment.storageUrl +  this.container + "/";


        this.http.get(this.path + this.name, { 
            responseType: 'blob' as 'json', 
            observe: 'response',
            headers: new HttpHeaders({ Range: 'bytes=0-0' }), 
        }).subscribe(res => {            
            const contentType = res.headers.get('content-type') ?? '';
            this.is_image = contentType.includes("image/");
            this.is_audio = contentType.includes("audio/");

            // sometimes the content disposition is not return for some reason, maybe because its not authenticated
            // @see https://stackoverflow.com/questions/54207583/azure-blob-storage-v2-does-not-deliver-content-disposition-header-any-more
            this.filename = res.headers.get('content-disposition')?.replace("filename=", "") ?? "";
            
            if (this.base64regex.test(this.filename)) {
                this.filename = this.b64DecodeUnicode(this.filename);
            }

            const contentRange = res.headers.get('content-range'); // "bytes 0-0/121928"
            const totalSize = contentRange ? +contentRange.split('/')[1] : +res.headers.get('content-length');
            this.size = this.formatBytes(totalSize);

            this.cd.detectChanges();
        });    
    }

     b64DecodeUnicode(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    formatBytes(bytes, decimals = 1) {
        if (!+bytes) return '0b';
    
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['n', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
    
        const i = Math.floor(Math.log(bytes) / Math.log(k));
    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}${sizes[i]}`;
    }

	openModal(){
        const ref = this.modalService.open( AttachmentImageComponent, { centered: true, modalDialogClass: 'attachment-modal' });
        ref.componentInstance.image_source = this.path + this.name;
    }

}

